<template>
  <el-row
    type="flex"
    justify="space-between"
    align="middle"
  >
    <div>
      <h1 class="card-container__title">{{ title }} <span class="card-container__subtitle">({{ total }})</span></h1>
    </div>
    <el-row
      class="card-container__actions"
      type="flex"
      justify="end"
      align="middle"
    >
      <el-button
        v-if="headerActions.includes('reset')"
        class="ml-s"
        type="primary"
        size="medium"
        icon="el-icon-refresh"
        :plain="plain"
        :disabled="disabled"
        @click="$emit('refresh')"
      />
      <export-excel-button
        v-if="headerActions.includes('export')"
        class="ml-s"
        :title="title"
        :disabled="disabled || !columns.length"
        :total="total"
        :columns="columns"
        :object-type="objectType"
        :type="type"
        :filter-params="filterParams"
        :show-text="false"
      />
    </el-row>
  </el-row>
</template>

<script>
import ExportExcelButton from "@/components/buttons/ExportExcel.vue";

export default {
  name: "CardHeader",
  components: {
    ExportExcelButton,
  },
  props: {
    config: Object,
    total: Number,
    disabled: Boolean,
    plain: Boolean,
    size: String,
    permission: Object,
    contract: Object,
    currentContractStatus: Object,
    filterParams: Object,
  },
  computed: {
    title() {
      if (!this.contract) {
        return this.config.extra.info.menu || "";
      }
      if (this.currentContractStatus) {
        return `Danh sách ${this.config.extra.name} ${this.currentContractStatus.name}`
      }
      return `Danh sách ${this.config.extra.name} chưa có trạng thái`
    },
    headerActions() {
      return (this.config.extra?.header_actions || [])
    },
    columns() {
      const data = this.config.extra?.fields || [];
      return data
        .filter((i) => i.show.import_export)
        .sort((a, b) => a.order - b.order);
    },
    objectType() {
      return this.config.type;
    },
    type() {
      return this.config.extra.key;
    },
    importTemplates() {
      return this.config.extra.import_templates || []
    }
  },
};
</script>

<style lang="scss" scoped></style>
